
import SsrCarousel from 'vue-ssr-carousel'
import { mapGetters, mapActions } from 'vuex'

export default {
    name: "GradStories",
    components: { SsrCarousel },
    props: {
        region: { default: 'IE', type: String },
        count: { default: 3, type: Number },
        content: { default: true, type: Boolean },
        bg: { default: 'grey', type: String },
    },
    computed: {
        ...mapGetters({
            activeModal: 'pages/getActiveModal'
        }),
    },
    methods: {
        ...mapActions({
            updateActiveModal: 'pages/updateActiveModal'
        }),
        updateModal(id) {
            this.updateActiveModal(id)
        },
        hideModal() {
            this.updateActiveModal(null)
        }
    }
}
